var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgOptionExpand = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#696969",
    d: "M7.746 18.242a.583.583 0 1 1-.825-.825l5.42-5.42-5.42-5.421a.583.583 0 1 1 .825-.825l5.833 5.833a.583.583 0 0 1 0 .825z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#696969",
    d: "M11.246 18.242a.583.583 0 1 1-.825-.825l5.42-5.42-5.42-5.421a.583.583 0 1 1 .825-.825l5.833 5.833a.583.583 0 0 1 0 .825z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOptionExpand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/option-expand.968aa142.svg";